module.exports = __webpack_public_path__ + "static/media/newsletter-march-2022-3.147ecdf5.png";